module.exports = __webpack_public_path__ + "static/media/wendy_cabrera_rubio_5.9e47010c.jpg";